
// ********* Import CSS ***************** //

import '@styles/main.scss';
import "./recent-camps-classes.css";

// ****************************** Import Images ******************************** //

// ** CURRENT FLYER IMAGES **//
// import "/src/assets/summer-camp-2026/sc2026-web-flyer.jpg";

// ** LOADING SPINNER - GCS Computer ** //
// import "/src/assets/logos/gcs-logo-pink-comp-only.png";

// ** GCS LOGO ** //
// import "/src/assets/logos/gcs-logo-pink-background.png";

// ** GCS Wordmark ** //
// import "/src/assets/logos/gcs-wordmark-code-pink.png";

// import "/src/assets/icons/arrow-right-purple.png"


// ********* Add Top Nav & Footer *************** //

import '/src/nav-header-footer/nav-header-footer.js';
import '/src/nav-header-footer/nav-header-footer.css';


// ************ Add JS for Email Signup & Error Popup *************** //

import '/src/nav-header-footer/email-contact-new-classes.js';

// **************************** Loading Spinner ****************************** //

window.addEventListener('DOMContentLoaded', () => {
  const preloader = document.getElementById("preloader");
  
  if (preloader) {
    preloader.style.display = "block";
    
    window.addEventListener('load', () => {
      setTimeout(() => {
        preloader.style.transition = "opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
        preloader.style.opacity = "0";
        
        setTimeout(() => {
          preloader.remove();
        }, 300);
      }, 800);
    });
  }
});

// **************************** Close FAQ From Inside ****************************** //

const closeFaqBtn = document.querySelectorAll('.faq-close');

  closeFaqBtn.forEach(button => {
    button.addEventListener('click', (e) => {
      const parentDetails = e.target.closest('details');
      
      // Close it
      if (parentDetails) {
        parentDetails.removeAttribute('open');
        parentDetails.classList.add('fade-out');
      }

      button.addEventListener('transitionend', () => {
        window.close(); // No manual delay needed
      }, { once: true });

    });
  });
